import { GoogleMap } from '~src/components/GoogleMap';
import { useGeolocationLookup } from '~src/hooks/useDAWA';
import { AddressWithBbrId } from '~src/model';

const MAP_SIZE = 82;

type CustomerHouseMapProps = { address: Partial<AddressWithBbrId> };

export const CustomerHouseMap = ({ address }: CustomerHouseMapProps) => {
  const coordinates = useGeolocationLookup(address);

  const center =
    coordinates?.latitude && coordinates?.longitude
      ? { lat: coordinates.latitude, lng: coordinates.longitude }
      : undefined;

  return (
    <div style={{ width: MAP_SIZE, height: MAP_SIZE, marginRight: '8px' }}>
      <GoogleMap
        zoomControl={false}
        zoom={18}
        center={center}
        height={MAP_SIZE}
        fullscreenControl={false}
        controlSize={0}
        tilt={0}
        disableDefaultUI={true}
        disableDoubleClickZoom={true}
        hideMarker={true}
      />
    </div>
  );
};
